<template>
  <div class="page password-change">
    <div class="page-inner">
      <PasswordChangeForm ref="refUserForm" :userData="userData" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PasswordChangeForm from "../signUp/comp/userForm/PasswordChangeForm.vue";
const modelService = require("@/utils/dataModel.js");
export default {
  components: {
    PasswordChangeForm,
  },
  data() {
    return {
      userData: modelService.userModel(),
    };
  },
  mounted() {
    if (this.meInfo === null) {
      this.getMeInfo().then(() => {
        this.userData = this.meInfo;
        this.makePassword();
      });
    } else {
      this.userData = this.meInfo;
    }
    this.userData.password = "";
    console.log("this.userData", this.userData);
    this.makePassword();
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  methods: {
    ...mapActions(["getMeInfo"]),
    makePassword() {
      if (this.isDev) {
        this.userData.currentPassword = "1875";
        this.userData.password = "18751875!";
        this.userData.rePassword = "18751875!";
        // this.userData.currentPassword = "123456789001!";
        // this.userData.password = "123456789!";
        // this.userData.rePassword = "123456789!";
      }
    }
  },
};
</script>
<style lang="scss">
.password-change {
  &.page {
    min-height: auto;


    .page-inner {
      padding: 20px;
      height: calc(100svh - 200px);
      position: relative;

      .v-btn:not(.v-btn--round).v-size--x-large {
        margin-top: 30px;
      }
    }
  }

}
</style>
